import api from '../../api'
import router from '../../router'

const actions = {
  getArticleAction ({ commit }, uri) {
    return api.getArticle(uri)
      .then(response => commit('article/setCurrentArticle', response.data.article, { root: true }))
      .catch(e => {
        if (typeof e === 'undefined') {
          commit('logError', 'Error undefined - Safari CORS issue likely.', { root: true })
          router.push('/search')
        } else {
          if (e.response.data.status === 404) router.push(`/wiki/${uri}/history`)
          else {
            commit('logError', e, { root: true })
            router.push('/unauthorized')
          }
        }
      })
  },
  getArticleHistoryAction ({ commit }, uri) {
    return api.getArticleHistory(uri)
      .then(response => commit('article/setArticleHistory', response.data, { root: true }))
      .catch(e => {
        if (typeof e === 'undefined') {
          commit('logError', 'Error undefined - Safari CORS issue likely.', { root: true })
          router.push('/search')
        } else {
          if (e.response.data.status === 404) router.push(`/wiki/${uri}/new`)
          else {
            commit('logError', e, { root: true })
            router.push('/unauthorized')
          }
        }
      })
  },
  getArticlesAction ({ commit }) {
    return api.getArticles()
      .then(response => commit('article/setArticleHierarchy', response.data, { root: true }))
      .catch(e => commit('logError', e, { root: true }))
  },
  deleteArticleAction ({ commit, dispatch, rootState }, uri) {
    return api.deleteArticle(uri, rootState.article.deletionChildrenAction, rootState.article.deletionNote)
      .then(response => dispatch('getArticlesAction'))
      .catch(e => commit('logError', e, { root: true }))
  },
  createArticleAction ({ commit, dispatch, rootState }, uri) {
    return api.createArticle(uri, rootState.article.articleEdits)
      .then(response => {
        dispatch('getArticlesAction')
        router.push(`/wiki/${response.data.article.uri}`)
      })
      .catch(e => commit('logError', e, { root: true }))
  },
  editArticleAction ({ commit, dispatch, rootState }, uri) {
    return api.editArticle(uri, rootState.article.articleEdits, rootState.article.editIsRestore)
      .then(response => {
        dispatch('getArticlesAction')
        commit('article/setEditIsRestore', false, { root: true })
        router.push(`/wiki/${response.data.article.uri}`)
      })
      .catch(e => commit('logError', e, { root: true }))
  },
  searchAction ({ commit, rootState }, field = '') {
    return api.search(rootState.article.searchString, field)
      .then(response => commit('article/setSearchResults', response.data.articles, { root: true }))
      .catch(e => commit('logError', e, { root: true }))
  }
}

export default {
  namespaced: true,
  actions
}
